import { render, staticRenderFns } from "./AddNewMedicineDialog.vue?vue&type=template&id=d144bb9c&scoped=true&lang=pug&"
import script from "./AddNewMedicineDialog.vue?vue&type=script&lang=js&"
export * from "./AddNewMedicineDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNewMedicineDialog.vue?vue&type=style&index=0&id=d144bb9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d144bb9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSpacer,VTextField})
